import { safeDefineFsComponent } from '@cof/safe-custom-element-define';
import { FsAccordion as Accordion } from './src/Accordion.js';
import { FsAccordionItem as AccordionItem } from './src/AccordionItem.js';
const FsAccordionConstructor = safeDefineFsComponent.define(Accordion).customElementClass;
const FsAccordionItemConstructor = safeDefineFsComponent.define(AccordionItem).customElementClass;
export const FsAccordion = FsAccordionConstructor;
export const FsAccordionItem = FsAccordionItemConstructor;
//# sourceMappingURL=fs-accordion.js.map